var App = App || {};

App.Masthead = (function ($) {
    "use strict";

    function init() {
        $(".widget-masthead[data-db-dime='true']").each(function () {
            const masthead = $(this);

            if (masthead.children(".widget-masthead-dime-bg.zag-parallax-bg").length) {
                masthead.ZagParallax({ divisor: 2 });
            }
        });
    }

    return {
        init: init
    };
})(jQuery);

$(function () {
    App.Masthead.init();
});
